import { getLinkCreatedBy } from '@/components/traceInspector/segmentUserDetail/segmentUserDetail.utils';
import { AvatarComponent } from '@/components/ui/avatar/avatar';
import type { LinkQueryResult } from '../traceInspector.types';

type Props = {
  link: LinkQueryResult;
  linkCreatedByAccount: any;
};

/**
 * Links are created by an account.
 * However, its entity can be null if the current user is a collaborator
 * and the entity is not visible to the group.
 * The display falls back to the link group in that case.
 */
export const SegmentUserDetail = ({ link, linkCreatedByAccount }: Props) => {
  const createdBy = getLinkCreatedBy(link, linkCreatedByAccount);

  if (!createdBy) {
    return (
      <div className="flex w-full items-center gap-2 break-words border-border border-b pb-4 text-foreground">
        <div className="mr-2 shrink-0 pt-1">
          <AvatarComponent
            name={link.group.name}
            size={44}
            source={link.group.avatar}
          />
        </div>
        <div>
          <div className="flex w-full items-start gap-4 px-1">
            <div className="mr-2 font-semibold text-lg">{link.group.name}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center gap-2 break-words border-border border-b pb-4 text-foreground">
      <div className="mr-2 shrink-0 pt-1">
        <AvatarComponent
          name={createdBy.name}
          size={44}
          source={createdBy.avatar}
        />
      </div>
      <div>
        <div className="flex w-full items-center gap-4 py-1">
          <div className="mr-2 font-semibold text-lg">{createdBy.name}</div>
        </div>
        <div className="text-muted-foreground text-sm">
          {createdBy.email && (
            <div>
              <a
                className="text-inherit no-underline hover:text-primary"
                href={`mailto:${createdBy.email}`}
              >
                {createdBy.email}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
